import { getColModelItem } from '../../../services/lib/utils/helpers'
import { urlKey } from '../../../services/api/api-urls'
import moment from 'moment'

export default class OnlineUserManagementColumnModel {
	static Column = [
	  {
	    title: 'Username',
	    align: 'left',
	    field: 'userName'
	  },
	  {
	    title: 'Password',
	    align: 'left',
	    field: 'password',
		  editable: 'onAdd',
		  render: (rowData: any) => null
	  },	  
	  {
	    ...getColModelItem({
	      title: 'Customer',
	      field: 'customer',
	      keywords: [
	        urlKey.Customer
	      ]
	    }, () => ([{key: urlKey.Customer, label: '', otherOptions: {type: 'select', isOverrideSelectionOptions: true, valueJoinArray: ['company', 'customerCode']}}])),
		  render: (rowData: any) => rowData.customer ? (rowData.customer?.company + ' ' + rowData.customer?.customerCode) : ''
	  },
	  {
	    title: 'Created At',
	    align: 'left',
	    field: 'createdAt',
	    // 默认按创建时间排序，新创建的在前
	    defaultSort: 'desc',
	    render: (rowData: any) => {
	      const v = rowData.createdAt || rowData.createAt
	      return v ? moment.utc(v).local().format('DD/MM/YYYY HH:mm') : ''
	    }
	  },
	]
}

